import React from "react"
import { Route, Redirect, RouteProps, RouteComponentProps } from "react-router-dom"
import { useUserStatus } from "../../../subscriptions-web/hooks/use-user-status"

export const VerifiedUserRoute = ({
	component: RouteComponent,
	...restProps
}: { component: React.ComponentType<any> } & RouteProps) => {
	const {
		userSignedInAnonymously,
		userSignedInWithEmailNotVerified,
		userSignedInWithEmailVerified,
		isProSubscriptionActive,
	} = useUserStatus()

	const renderRouter = (routeProps: RouteComponentProps<any>) => {
		if (userSignedInWithEmailVerified) {
			return <RouteComponent {...routeProps} />
		} else if (userSignedInAnonymously && isProSubscriptionActive) {
			return <Redirect to={"/confirm-email"} />
		} else if (userSignedInWithEmailNotVerified) {
			return <Redirect to={"/confirm-email"} />
		} else {
			return <Redirect to={"/signin"} />
		}
	}

	return <Route {...restProps} render={renderRouter} />
}
